<template>
  <div class="mx-4 mb-4 leading-normal flex flex-col" :class="wrapperClasses">
    <div
      :class="[isOutgoing ? 'flex-row-reverse' : 'flex-row', 'flex justify-start']"
    >
      <div
        class="rounded-lg px-3 min-w-0"
        :class="[
          (isIncoming && involvesCurrentUser) ? 'bg-green-500 text-white' : '',
          (isOutgoing && involvesCurrentUser) ? 'bg-blue-500 text-white' : '',
          (!involvesCurrentUser) ? 'bg-gray-300 text-gray-600' : '',
          (isIncoming) ? 'text-left' : '',
        ]"
      >
        <MessageImage
          v-for="file in messageFiles"
          :url="file.url"
          :key="file.id"
          :height="file.height"
          :width="file.width"
        />
        <div :class="[isOutgoing ? 'flex-col' : 'flex-col-reverse', 'flex']">
          <div
            v-for="body in bodies"
            class="my-3 flex flex-col"
            :key="body.id"
            :class="{'text-sm': !body.isCanon}"
          >
            <div v-for="line in bodyTextLines(body)" :key="line.id" class="break-words" style="word-break: break-word;">
              {{ line.length == 0 ? '&nbsp' : line}}
            </div>
          </div>
        </div>
      </div>
      <div class="flex-shrink-0 w-12 md:w-28">
        <!-- spacer for message justification -->
      </div>
    </div>
    <div
      class="mt-1 text-gray-500 text-xs"
      :class="[isOutgoing ? 'text-right' : 'text-left']"
    >
      <span class="font-bold" :class="{'text-red-700': messageFailed}">
        {{status}}
      </span>
      <span>
        {{statusNarrative}}
      </span>
      <span class="font-bold">
        {{displayName}}
      </span>
      <div v-if="tagsNarrative">
        {{tagsNarrative}}
      </div>
    </div>
  </div>
</template>

<script>
import parse        from 'date-fns/parse'
import format       from 'date-fns/format'
import _get         from 'lodash-es/get'
import _map from 'lodash-es/map'
import _split from 'lodash-es/split'
import _join from 'lodash-es/join'
import _orderBy         from 'lodash-es/orderBy'

import Dropdown     from '@/components/Dropdown.vue'
import MessageImage from '@/components/MessageImage.vue'

export default {
  components: {
    Dropdown,
    MessageImage
  },

  props: {
    communication: {
      required: true
    }
  },

  computed: {
    bodies() {
      return _orderBy(_get(this.communication, 'bodies'), ['isCanon', 'desc'])
    },

    canEdit() {
      return _get(this.communication, 'canEdit')
    },

    displayName() {
      if (this.involvesCurrentUser) {
        return ''
      } else {
        return _get(this.communication, 'conversation.teacherPhoneNumber.displayName')
      }
    },

    messageClasses() {
      if (this.communication.direction === "incoming") {
        return "bg-gray-300"
      } else {
        return "bg-green"
      }
    },

    messageFailed() {
      return this.status == 'Failed'
    },

    messageFiles() {
      return _get(this.communication, 'messageFiles', [])
    },

    shouldSkipQuery() {
      return this.needsStatusUpdate && this.isOutgoing
    },

    formattedTimestamp() {
      const date = parse(_get(this.communication, 'insertedAt'))
      return format(date, 'h:mm a')
    },

    involvesCurrentUser() {
      return _get(this.communication, 'involvesCurrentUser')
    },

    isIncoming() {
      return _get(this.communication, 'direction') == "incoming"
    },

    isOutgoing() {
      return _get(this.communication, 'direction') == "outgoing"
    },

    involvesCurrentUser() {
      return _get(this.communication, 'involvesCurrentUser') || false
    },

    messageClasses() {
      if (this.isIncoming && this.involvesCurrentUser) {
        return ['bg-green-500', 'text-left', 'text-white']
      } else if (this.involvesCurrentUser) {
        return ['bg-blue-500', 'text-white']
      } else {
        return ['bg-gray-300', 'text-gray-600']
      }
    },

    needsStatusUpdate() {
      return this.status == "Queued" || this.status == "Sending"
    },

    direction() {
      if (this.involvesCurrentUser) {
        return ''
      } else if (this.isIncoming) {
        return 'to '
      } else {
        return 'by '
      }
    },

    status() {
      let commStatus = _get(this.communication, 'status')

      if (this.isIncoming || !commStatus || commStatus == 'delivered' || commStatus == 'sent') {
        return ''
      } else {
        return commStatus.charAt(0).toUpperCase() + commStatus.slice(1)
      }
    },

    statusPreposition() {
      let commStatus = _get(this.communication, 'status')

      if (this.isIncoming || !commStatus || commStatus == 'delivered' || commStatus == 'sent') {
        return ''
      } else {
        return ' at '
      }
    },

    statusNarrative() {
      return _join([this.statusPreposition, this.formattedTimestamp, this.direction], ' ')
    },

    tagsNarrative() {
      var tags = _get(this.communication, 'moods') || []
      var tagNames = _map(tags, 'name')

      if (tags.length == 0) {
        return null
      } else {
        return _join(tagNames, ', ')
      }
    },

    wrapperClasses() {
      if (this.isIncoming) {
        return ['self-start', 'text-left']
      } else {
        return ['self-end', 'text-right']
      }
    }
  },

  methods: {
    bodyTextLines(body) {
      var lines = _get(body, 'text').replace(/\r\n|\n|\r/g,"<br />")
      return _split(lines, '<br />')
    }
  }
}
</script>
